import { Box, Skeleton } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import SkeletonList from './SkeletonList';

function SkeletonListBoxSelector() {
  return (
    <Box sx={{ marginTop: 2, marginBottom: 2, height: 400 }}>
      <Grid2 container spacing={2} justifyContent="center" alignItems="center">
        <Grid2 md={5}>
          <SkeletonList count={8} />
        </Grid2>
        <Grid2 md={2}>
          <Skeleton
            animation={false}
            variant="rectangle"
            sx={{ height: '100px' }}
          />
        </Grid2>
        <Grid2 md={5}>
          <SkeletonList count={8} />
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default SkeletonListBoxSelector;
